import { FC, useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import "./Collection.scss";
import { PublicKey } from "@solana/web3.js";
import { useParams } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

import Header from "../../components/Header";
import NFTCard from "../../components/NFTCard";
import NoContent from "../../components/NoContent";
import ApiService from "../../services/ApiService";
import Footer from "../../components/Footer";
import "../../assets/scss/common.scss";

export const WalletCollectionPage: FC = () => {
	const { public_key } = useParams();

	const [gifList, setGifList] = useState([]);
	const [isKeyValid, setIsKeyValid] = useState(true);
	const [errorMsg, setErrorMsg] = useState("");
	const [hasMore, setHasMore] = useState(true);
	const [pagination, setPagination] = useState({
		page: 1,
		pageSize: 40,
	});

	async function fetchNFT(page) {
		const currentPage = page || pagination.page;

		const result = await fetchNFTByOwnerAddress(
			currentPage,
			pagination.pageSize
		);

		if (result) {
			let newList = page === 1 ? [] : [...gifList];
			setGifList([...newList, ...result?.assets]);
			if (result.totalPages === currentPage) {
				setHasMore(false);
			}
			setPagination({
				...pagination,
				page: currentPage + 1,
			});
		} else {
			setHasMore(false);
		}
	}

	async function fetchNFTByOwnerAddress(page, pageSize) {
		try {
			const response = await ApiService.GetNftByWalletAddress(
				public_key,
				page,
				pageSize
			);
			if (response && response?.data && response.data?.result) {
				const result = response.data.result;
				if (result?.totalPages === 0) {
					setErrorMsg("We couldn't find anything");
				}
				return result;
			}
			return false;
		} catch (error) {
			setErrorMsg("Something went wrong");
		}
	}

	async function handleNFTs(key) {
		if (key) {
			try {
				const address: any = new PublicKey(key);
				if (PublicKey.isOnCurve(address)) {
					fetchNFT(1);
					setIsKeyValid(true);
					setErrorMsg("");
				} else {
					setInvalidKey();
				}
			} catch (error) {
				setInvalidKey();
			}
		}
	}

	const setInvalidKey = () => {
		setIsKeyValid(false);
		setErrorMsg("Please enter a valid key");
		setHasMore(false);
	};

	useEffect(() => {
		setGifList([]);
		setPagination({
			page: 1,
			pageSize: 40,
		});
		setHasMore(true);
		if (public_key) {
			handleNFTs(public_key);
		}
	}, [public_key]);

	return (
		<>
			<Header />
			<main className="main-content">
				<div className="inner-content">
					<section className="landing-main-wrapper">
						{isKeyValid && !errorMsg ? (
							<Container>
								<InfiniteScroll
									dataLength={gifList.length}
									next={async () => {
										await fetchNFT(null);
									}}
									scrollThreshold={0.6}
									hasMore={hasMore}
									loader={<h1 className="loading">Loading ...</h1>}
									style={{ overflow: "hidden" }}
								>
									<Row>
										{gifList.map((hero, i) => {
											let item = { ...hero, page: "Key-CollectionPage" };
											return <NFTCard key={i} index={i} item={item} />;
										})}
									</Row>
								</InfiniteScroll>
							</Container>
						) : (
							<NoContent msg={errorMsg} />
						)}
					</section>
				</div>
				<Footer></Footer>
			</main>
		</>
	);
};
